import {Module} from "vuex";
import {RootState} from "@/store/types";
import {partners} from "@/store/settings/partners";
import {originators} from "@/store/settings/originators";
import {systemSettings} from "@/store/settings/system_settings";
import {duplicates} from "@/store/settings/duplicates";
import {quantityLimits} from "@/store/settings/quantity_limits";
import {serviceProviders} from "@/store/settings/service_providers";
import {providerConnections} from "@/store/settings/provider_connections";
import {smppConnections} from "@/store/settings/smpp_connections";
import {messageTypes} from "@/store/settings/message_types";
import {messageCategories} from "@/store/settings/message_categories";
import {accounts} from "@/store/settings/accounts";
import {reports} from "@/store/settings/reports";
import {preprocessingRules} from "@/store/settings/preprocessing_rules";
import {pools} from "@/store/settings/pools";
import {partnersConnections} from "@/store/settings/partners_connections";
import {template} from "@/store/settings/templates";
import {blacklists} from "@/store/settings/blacklists";
import {whiteLists} from "@/store/settings/white_list";
import {proxySettings} from "@/store/settings/proxy_settings";
import {priorityRules} from "@/store/settings/priority_rules";
import {templateParams} from "@/store/settings/template_params";

export const settingsModule: Module<any, RootState> = {
    modules: {
        partners,
        originators,
        systemSettings,
        duplicates,
        quantityLimits,
        serviceProviders,
        providerConnections,
        smppConnections,
        preprocessingRules,
        messageTypes,
        messageCategories,
        accounts,
        reports,
        pools,
        partnersConnections,
        template,
        blacklists,
        whiteLists,
        proxySettings,
        priorityRules,
        templateParams
    }
}
